import React from 'react';
import { connect, useSelector } from 'react-redux'
import { useState, useMemo, useEffect } from 'react'

import pageWithSideMenu from '../../../containers/pageWithSideMenu'
import pageContent from '../../../containers/pageContent'

import toolsAPICall from '../../../app/apiCalls/toolsAPICall'
import { tool_details, tool_chatyourmatch_profiles, tool_chatyourmatch_save } from "../../../app/apiEndpoints" //tool_lp_dashboard_boost
import DataTable from "../../../containers/DataTable";
import { Card, Row, Col, Breadcrumb, FormGroup, FormLabel } from 'react-bootstrap'
import Form from '../../../containers/Form/Form'
import Select from "../../../containers/Form/Select";
import Input from '../../../containers/Form/Input';
import Button from '../../../containers/Form/Button';
import { tableTypes } from '../../../app/settings'
import CardHeader from '../../../containers/CardHeader';

import Moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const ChatYourMatchTool = (props) => {
    const toolID = 25
    const [tool, setTool] = useState({})
    const tableID = "profile"

    const userID = useSelector((state) => state.user.id)
    const companyID = useSelector((state) => state.user.company.id)
    const isSysadmin = useSelector((state) => state.user.isSysadmin)

    const [profiles, setProfiles] = useState([])
    const [streams, setStreams] = useState([])

    const [inputValue, setInputValue] = useState({ profileID: 0, username: "", personality: "", intro: "", autoSend: false, displayOrder: 1, isActive: 1 });
    const [errors, setErrors] = useState({ profileID: "", username: "", personality: "", intro: "", autoSend: "", displayOrder: "", isActive: "" });
    const { profileID, username, personality, intro, autoSend, displayOrder, isActive } = inputValue;
    const [formMessage, setFormMessage] = useState('')
    const canEdit = isSysadmin

    const [startDate, setStartDate] = useState(new Date(Moment().add(-1, 'days').format('MM/DD/YYYY')))
    const [endDate, setEndDate] = useState(new Date(Moment().format('MM/DD/YYYY')))

    const tableFields = ["ID", "Username", "Personality", "Auto-Message", "# Imgs", "# Restricted", "Likes", "Dislikes", "Chats Started", "Chat CTAs", "CTAs Clicked", "CTA CTR", "Active?"]
    const tableFieldName = ["id", "username", "personality", "send_on_start", "img_count", "restricted_count", "total_likes", "total_dislikes", "total_chats_sent", "total_chat_ctas", "total_chat_clicked", "", "is_active"]

    const [sortField, setSortField] = useState('total_likes')
    const [sortDirection, setSortDirection] = useState(1)
    const [sortFieldCams, setSortFieldCams] = useState('total_likes')
    const [sortDirectionCams, setSortDirectionCams] = useState(1)

    const [runStatus, setRunStatus] = useState(1)

    const [showOverlay, setShowOverlay] = useState(false);

    const [profile, setProfile] = useState(null)

    const personalities = [
        {ID: 1, NAME: "1: Warm Demure"}, 
        {ID: 2, NAME: "2: Slutty Tease"},
        {ID: 3, NAME: "3: Bold Direct"},
        {ID: 4, NAME: "4: Begging Desperate"},
        {ID: 5, NAME: "5: Granny"},
        {ID: 6, NAME: "6: Trans"},
    ]

    const displayOrders = [
        {ID: 2, NAME: "First"}, 
        {ID: 1, NAME: "Normal"},
    ]

    useMemo(() => {
        const getDetails = async () => {
            if(toolID > 0) {
                const data = await toolsAPICall(tool_details, {'toolID': toolID, 'requester': userID, 'company': companyID })
                setTool(data.tool)
            }
        }
        getDetails()
    }, [toolID, userID, companyID])

    useEffect(() => {
        const getStats = async () => {
            if(toolID > 0) {
                setRunStatus(2)
                const data = await toolsAPICall(tool_chatyourmatch_profiles, { 
                    'requester': userID, 
                    'company': companyID,
                    'startDate': Moment(startDate).format('YYYY-MM-DD'), 
                    'endDate': Moment(endDate).format('YYYY-MM-DD')
                })
                setProfiles(data.profiles)
                setStreams(data.streams)
                setRunStatus(0)
            }
        }
        if(runStatus === 1) {
            getStats()
        }
    }, [userID, companyID, startDate, endDate, runStatus])

    const selectProfile = (e) => {
        e.preventDefault();
        let rowID = e.currentTarget.id
        rowID = rowID.replace(`${tableID}_`, "")

        let foundItem = profiles.find(obj => obj.id === rowID);
        if(!foundItem) {
            foundItem = streams.find(obj => obj.id === rowID);
        }

        setInputValue((prev) => ({
            ...prev,
            'profileID': rowID,
            'username': foundItem.username,
            'personality': foundItem.personality,
            'intro': foundItem.introduction,
            'autoSend': foundItem.send_on_start,
            'displayOrder': foundItem.display_order,
            'isActive': foundItem.is_active,
          }));
        setProfile(foundItem)

    };

    const handleOpen = (e) => {
        e.preventDefault();
        setShowOverlay(true);
    };

    const handleClose = () => {
        setShowOverlay(false);
    };

    // const genRevReport = async (e) => {
    //     e.preventDefault()
    //     setRevCsvStatus(1)
    //     const csvData = await toolsAPICall(tool_lp_dashboard_data, { 'requester': userID, 'company': companyID, 'report': 1, 'subpid': curPid, 'geo': curGeo, 'devicetype': curDevice, 'answerid': curAnswer, 'startDate': Moment(startDate).format('YYYY-MM-DD'), 'endDate': Moment(endDate).format('YYYY-MM-DD'), 'cascadeType': cascadeType })
    //     if(csvData.revcsv) { 
    //         setRevCsv(csvData.revcsv)
    //         setRevCsvStatus(2)
    //     }
    // }

    // const genRegReport = async (e) => {
    //     e.preventDefault()
    //     setRegCsvStatus(1)
    //     const csvData = await toolsAPICall(tool_lp_dashboard_data, { 'requester': userID, 'company': companyID, 'report': 2, 'subpid': curPid, 'geo': curGeo, 'devicetype': curDevice, 'answerid': curAnswer, 'startDate': Moment(startDate).format('YYYY-MM-DD'), 'endDate': Moment(endDate).format('YYYY-MM-DD'), 'cascadeType': cascadeType })
    //     if(csvData.revcsv) { 
    //         setRegCsv(csvData.revcsv)
    //         setRegCsvStatus(2)
    //     }
    // }

    const tableData = (type) => {
        let values = type === 1 ? profiles : streams
        const sortFieldToUse = type === 1 ? sortField : sortFieldCams
        const sortDirectionToUse = type === 1 ? sortDirection : sortDirectionCams

        // Sort values before mapping
        values = [...values].sort((a, b) => {
            // Always move "TOTAL" to the bottom
            if (a.path === "TOTAL") return 1;
            if (b.path === "TOTAL") return -1;

            let aValue = a[sortFieldToUse];
            let bValue = b[sortFieldToUse];

            // Convert to number if field is numeric
            if (['id','personality','total_likes','total_dislikes','total_chat_ctas','total_chats_sent','total_chat_clicked','is_livestream','img_count','restricted_count','send_on_start'].includes(sortFieldToUse)) {
                aValue = parseInt(aValue);
                bValue = parseInt(bValue);
            } else {
                aValue = String(aValue).toLowerCase();
                bValue = String(bValue).toLowerCase();
            }

            if (aValue < bValue) return sortDirectionToUse === 0 ? -1 : 1;
            if (aValue > bValue) return sortDirectionToUse === 0 ? 1 : -1;
            return 0;
        });

        let rows = [];
        values.forEach(row => {
            rows.push({'id': row.id, 'values': [
                row.id,
                row.username,
                row.personality,
                row.send_on_start,
                row.img_count,
                row.restricted_count,
                row.total_likes,
                row.total_dislikes,
                row.total_chats_sent,
                row.total_chat_ctas,
                row.total_chat_clicked,
                row.total_chat_ctas > 0 ? (row.total_chat_clicked / row.total_chat_ctas).toFixed(2) : 0,
                row.is_active === "1" ? "Yes" : "No"
            ]});
        });
        return rows
    }

    const handleChange = (e) => {
        const { name, value } = e.target;
        console.log(`${name} = ${value}`)
        setInputValue((prev) => ({
          ...prev,
          [name]: value,
        }));
    };
    
    const handleError = (field, error) => {
          setErrors((prev) => ({
              ...prev,
              [field]: error,
          }));
    };

    const filterDate = (field, value) => {
        if(field === 1) setStartDate(value)
        else if(field === 2) setEndDate(value)
    }

    const sortData = (field, direction) => {
        let index = tableFields.indexOf(field)

        setSortField(tableFieldName[index])
        setSortDirection(direction)
    }

    const sortDataCams = (field, direction) => {
        let index = tableFields.indexOf(field)

        setSortFieldCams(tableFieldName[index])
        setSortDirectionCams(direction)
    }

    const runFilter = async () => {
        //setRevCsv({}); setRevCsvStatus(0);
        //setRegCsv({}); setRegCsvStatus(0);
      
        setProfiles([]);
        setStreams([]);
      
        setRunStatus(1)
      };

    const saveModel = async (e) => {
        e.preventDefault()
        
        setFormMessage('')
        let formErrors = []
        for (const field of Object.entries(errors)) {
            const error = field[1]
            if(error.length > 0) formErrors.push(error)
        }
        if(formErrors.length > 0) { 
            setFormMessage(formErrors.join('<br/>'))
            return
        }

        if(username.length === 0) {
            formErrors.push("You must enter a Model Username")
        }
        if(personality.length === 0) {
            formErrors.push("You must select a Personality")
        }
        if(formErrors.length > 0) { 
            setFormMessage(formErrors.join('<br/>'))
            return
        }

        const data = await toolsAPICall(tool_chatyourmatch_save, {
            'requester': userID, 
            'company': companyID, 
            'profileID': profileID, 
            'personality': personality, 
            'intro': intro, 
            'displayOrder': displayOrder,
            'autoSend': parseInt(autoSend) === 1 ? 1 : 0, 
            'isActive': parseInt(isActive) === 1 ? 1 : 0, 
            'startDate': Moment(startDate).format('YYYY-MM-DD'), 
            'endDate': Moment(endDate).format('YYYY-MM-DD')
        })

        //if successful, delete from project object
        if(data.error) {
            setFormMessage(data.error)
            return
        } 
        else {
            setProfiles(data.profiles)
            setStreams(data.streams)
            setFormMessage("Profile saved")
        }
    }

    if(!tool) return <></>

    return (
        <>
        <Breadcrumb>
          <Breadcrumb.Item href="/tools/">Tools</Breadcrumb.Item>
          <Breadcrumb.Item active>{tool.tool_name}</Breadcrumb.Item>
        </Breadcrumb>
            <Card>
            <CardHeader title={tool.tool_name} description={tool.description} />
                <Form description={tool.description} noCard={true} >
                    <Row>
                        <Col md={6}>
                            <strong>Filter Dates</strong>
                            <FormGroup>
                                <Row>
                                <FormLabel column sm="3" htmlFor={startDate}>Start Date</FormLabel>
                                <Col md={6}>
                                    <DatePicker id="startDate" name="startDate" selected={startDate} className="form-control" onChange={(date) => filterDate(1, date)} />
                                </Col>
                                </Row>
                            </FormGroup>
                            <FormGroup>
                                <Row>
                                <FormLabel column sm="3" htmlFor={endDate}>End Date</FormLabel>
                                <Col md={6}>
                                <DatePicker id="endDate" name="endDate" selected={endDate} className="form-control" onChange={(date) => filterDate(2, date)} />
                                </Col>
                                </Row>
                            </FormGroup>

                            <Button onClick={(e) => { e.preventDefault(); runFilter(); }} title="Filter Data" className="primary" /> 
                        </Col>
                        <Col md={6}>

                        <strong>{username?.length > 0 ? `Edit ${username}` : "Add Model"}</strong>
                            
                            <Input
                                type="text"
                                value={username}
                                placeholder="Username"
                                label="Username"
                                name="username"
                                readOnly={true}
                                validate="text|required"
                                colSize="6"
                            />
                            
                            <Select
                                value={personality}
                                label="Personality"
                                name="personality"
                                formValues={personalities}
                                useDefault={true}
                                onChange={handleChange}
                                validate="number|required"
                                colSize="6"
                            />   

                            <Input
                                type="text"
                                value={intro}
                                placeholder="Introduction"
                                label="Introduction"
                                name="intro"
                                readOnly={!canEdit}
                                onChange={handleChange}
                                onError={handleError}
                                validate="text|required"
                                colSize="6"
                            />  
                            
                            <Select
                                value={autoSend}
                                label="Auto-Send?"
                                name="autoSend"
                                formField="yesno"
                                useDefault={false}
                                onChange={handleChange}
                                validate="number|required"
                                colSize="6"
                            />  
                            
                            <Select
                                value={displayOrder}
                                label="Display Order"
                                name="displayOrder"
                                formValues={displayOrders}
                                useDefault={false}
                                onChange={handleChange}
                                validate="number|required"
                                colSize="6"
                            />  
                            
                            <Select
                                value={isActive}
                                label="Actve?"
                                name="isActive"
                                formField="yesno"
                                useDefault={false}
                                onChange={handleChange}
                                validate="number|required"
                                colSize="6"
                            />     

                            {formMessage.length > 0 && <p>{formMessage}</p> }

                            {profileID > 0 && 
                                <>
                                <Button title="View Images" className="secondary" onClick={handleOpen} /> 
                                <Button title="Save Model" className="primary" onClick={saveModel}  />
                                </>
                            }
                        </Col>
                    </Row>
            <Row>
                <Col md={12}>
                <DataTable hover={true} tableID={tableID} fieldNames={tableFields} onClick={selectProfile} dataRows={tableData(1)} tableSettings={tableTypes.None} hideTotal={true} sortData={sortData} defaultSortOrder={1} defaultSortColumn='Likes' />
                

                </Col>
            </Row>
            <CardHeader title="ChatYourMatch Cams Profiles" description="View data on cams profiles shown on ChatYourMatch" />
            <Row>
                <Col md={12}>
                <DataTable hover={true} tableID={tableID} fieldNames={tableFields} onClick={handleOpen} dataRows={tableData(2)} tableSettings={tableTypes.None} hideTotal={true} sortData={sortDataCams} defaultSortOrder={1} defaultSortColumn='Likes' />
                

                </Col>
            </Row>
            </Form>
        </Card>

        {showOverlay && (
                <div className="image-overlay d-flex justify-content-center align-items-center">
                <div className="overlay-content">
                    <button
                    type="button"
                    className="btn btn-light btn-sm close-btn"
                    onClick={handleClose}
                    >
                    ✕
                    </button>

                    <div className="image-grid">
                    {profile?.is_livestream === '0' && Array.from({ length: profile?.img_count }).map((_, i) => {
                        const idx = i + 1;
                        const img = `https://chatyourmatch.com/assets/img/models/${profile?.id}/${idx}.jpg`;
                        return (
                        <img
                        key={idx}
                        src={img}
                        alt={`overlay-${idx}`}
                        className="img-fluid rounded mb-3"
                        />
                        );
                        })
                    }
                    {profile?.is_livestream === '1' && 
                        <img
                        key={1}
                        src={profile?.avatar_url}
                        alt={`overlay-1`}
                        className="img-fluid rounded mb-3"
                        />
                    }
                    </div>
                </div>
                </div>
            )}
        </>
    )
}

export default connect(state => ({...state}))(pageWithSideMenu(pageContent(ChatYourMatchTool), "Chat Your Match Dashboard"));